import { useMemo as m } from "react";
import { copyRawValuesOnly as i } from "./atoms-v21265.js";
import { buildSVGAttrs as l } from "./atoms-v21191.js";
import { createSvgRenderState as a } from "./atoms-v21263.js";
import { isSVGTag as n } from "./atoms-v21193.js";
function V(e, s, y, o) {
  const r = m(() => {
    const t = a();
    return l(t, s, n(o), e.transformTemplate), {
      ...t.attrs,
      style: { ...t.style }
    };
  }, [s]);
  if (e.style) {
    const t = {};
    i(t, e.style, e), r.style = { ...t, ...r.style };
  }
  return r;
}
export {
  V as useSVGProps
};
